import PatientOverviewPAGoalSettingDailyActivityGoal from 'dashboard/templates/views/Patient/PA/PatientOverviewPAGoalSettingDailyActivityGoal';

export default {
  path: 'daily-activity-goal',
  name: 'PatientRecordPAGoalSettingDailyActivityGoal',
  component: PatientOverviewPAGoalSettingDailyActivityGoal,
  meta: {
    // title: 'Patient Record - Physical Activity - Goal Setting - Daily Activity Goal',
    // title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')} - ${t('pa.dailyActivityGoal')}`,
    // title: 'Start Moving - Goal Setting',
    title: t => `${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
